import { render } from "./LayoutAdmin.vue?vue&type=template&id=61444a88&ts=true"
import script from "./LayoutAdmin.vue?vue&type=script&lang=ts"
export * from "./LayoutAdmin.vue?vue&type=script&lang=ts"

import "./LayoutAdmin.vue?vue&type=style&index=0&id=61444a88&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__